export const CACHE_TIME = 60 * 10
